import { render, staticRenderFns } from "./ModelCard.vue?vue&type=template&id=9fc7f068&scoped=true"
import script from "./ModelCard.vue?vue&type=script&lang=js"
export * from "./ModelCard.vue?vue&type=script&lang=js"
import style0 from "./ModelCard.vue?vue&type=style&index=0&id=9fc7f068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc7f068",
  null
  
)

export default component.exports